<!-- 经纬度距离计算 -->
<template>
  <div class="campus-announcement">
    经纬度距离计算
  </div>
</template>

<script>
export default {
  components: {

  },
  data() {
      return {
      };
  },
  created() {

  },
  mounted() {

  },
  methods: {

  },
};
</script>

<style scoped lang="scss">
.campus-announcement {
  height: 100%;
  background-color: #fff;
}
</style>
